import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=a83db506"
import script from "./PlusIcon.vue?vue&type=script&lang=ts"
export * from "./PlusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports